import { useAbility } from '@/modules/identity/application/ability';
import { PollsPage } from '@/modules/polls/ui/pages';
import { AdminPollList } from '@/modules/polls/ui/components';

export const Polls = () => {
  const ability = useAbility();
  // OJO: no incluir 'read'/'update' acá — todo RESIDENT los tiene (ver encuestas y votar),
  // así que con eso siempre daba true y mandaba a los residentes a AdminPollList, que pega
  // a v1/polls (solo admin) en vez de v1/polls/active y les tiraba 403.
  const canManagePolls = ability.can('manage', 'all')
    || ability.can('manage', 'Poll')
    || ability.can('create', 'Poll')
    || ability.can('delete', 'Poll');

  if (canManagePolls) {
    return <AdminPollList />;
  }

  // Residente ve solo activas y puede votar
  return <PollsPage />;
};
